import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { RowBetween } from '../../../components/Row'
import { ButtonYellowLight } from '../../../components/Button'

const DropCardItem = styled.div`
  width: 325px;
  height: 510px;
  margin: 20px 0px;
  background: ${({ theme }) => theme.bsBg36};
  border-radius: 15px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  cursor: pointer;
  overflow: hidden;
  &:hover{
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.4);
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    height: auto;
  `}
`
const Picture = styled.img`
  width: 325px;
  height: 434px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    height: auto;
  `}
`
const DropRow = styled(RowBetween)`
  align-items: flex-start;
  padding: 20px 16px;
  align-items: center;
  box-sizing: border-box;
`
const DropText = styled.div`
  align-items: center;
`
const DropTitle = styled.div`
  
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 105.9%;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
`
// const DropInfo = styled.div`
//   
//   font-style: normal;
//   font-weight: normal;
//   font-size: 14px;
//   letter-spacing: 0.02em;
//   color: ${({ theme }) => theme.bsText28};
//   opacity: 0.8;
//   margin-top: 9px;
// `

const Button = styled(ButtonYellowLight)`
  width: 70px;
  height: 30px;
  color: #FF7A00;
  align-items: center;
  display: flex;
  line-height: 0px;
`

export default function DropCard({drop}: {drop: any}) {
  const history = useHistory();
  const goDrop = () => {
    history.push(drop.urlName)
  }

  return (
    <DropCardItem onClick={() => goDrop()}>
      <Picture src={drop.image}/>
      <DropRow>
        <DropText>
          <DropTitle>{drop.title}</DropTitle>
          {/* <DropInfo>{drop.info}</DropInfo> */}
        </DropText>
        <Button>Live</Button>
      </DropRow>
    </DropCardItem>
  )
}